(() => {
  const money = cents => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  const init = (root = document) => {
    root.querySelectorAll('[data-rg-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      const slides = [...slider.querySelectorAll('.rg-campaign')];
      let index = 0;
      const show = next => { slides[index].classList.remove('is-active'); index = (next + slides.length) % slides.length; slides[index].classList.add('is-active'); };
      slider.querySelector('.prev')?.addEventListener('click', () => show(index - 1));
      slider.querySelector('.next')?.addEventListener('click', () => show(index + 1));
    });
    root.querySelectorAll('.rg-shelf').forEach(shelf => {
      const rail = shelf.querySelector('[data-rg-rail]');
      shelf.querySelector('[data-rg-prev]')?.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .85, behavior: 'smooth' }));
      shelf.querySelector('[data-rg-next]')?.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .85, behavior: 'smooth' }));
    });
    root.querySelectorAll('[data-rg-product]').forEach(product => {
      if (product.dataset.rgProductReady) return;
      product.dataset.rgProductReady = '1';
      const image = product.querySelector('[data-rg-main-image]');
      const media = [...product.querySelectorAll('[data-rg-media]')];
      let mediaIndex = Math.max(0, media.findIndex(button => button.classList.contains('is-active')));
      let mediaTimer;
      const showMedia = next => {
        if (!image || !media.length) return;
        mediaIndex = (next + media.length) % media.length;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = media[mediaIndex].dataset.rgMedia;
        media.forEach((item, index) => item.classList.toggle('is-active', index === mediaIndex));
      };
      const stopMedia = () => clearInterval(mediaTimer);
      const startMedia = () => {
        stopMedia();
        if (media.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) mediaTimer = setInterval(() => showMedia(mediaIndex + 1), 3000);
      };
      media.forEach((button, index) => button.addEventListener('click', () => { showMedia(index); startMedia(); }));
      product.querySelector('.rg-gallery')?.addEventListener('mouseenter', stopMedia);
      product.querySelector('.rg-gallery')?.addEventListener('mouseleave', startMedia);
      product.querySelector('.rg-gallery')?.addEventListener('focusin', stopMedia);
      product.querySelector('.rg-gallery')?.addEventListener('focusout', startMedia);
      const preload = () => media.forEach(button => { const img = new Image(); img.decoding = 'async'; img.src = button.dataset.rgMedia; });
      document.readyState === 'complete' ? preload() : addEventListener('load', preload, { once: true });
      startMedia();
      const id = product.querySelector('[data-rg-variant-id]');
      const price = product.querySelector('[data-rg-price]');
      const compare = product.querySelector('[data-rg-compare]');
      const add = product.querySelector('[data-rg-add]');
      product.querySelectorAll('[data-rg-variant]').forEach(button => button.addEventListener('click', () => {
        product.querySelectorAll('[data-rg-variant]').forEach(item => item.classList.toggle('is-active', item === button));
        id.value = button.dataset.rgVariant;
        price.textContent = money(Number(button.dataset.price));
        const compareValue = Number(button.dataset.compare);
        compare.hidden = !compareValue || compareValue <= Number(button.dataset.price);
        compare.textContent = compare.hidden ? '' : money(compareValue);
        add.disabled = button.dataset.available !== 'true';
        add.textContent = add.disabled ? 'Indisponível' : 'Comprar agora';
      }));
    });
    const drawer = document.querySelector('.rg-drawer');
    if (drawer && !drawer.dataset.ready) {
      drawer.dataset.ready = '1';
      const toggle = open => { drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', String(!open)); document.documentElement.style.overflow = open ? 'hidden' : ''; };
      document.querySelector('.rg-menu-open')?.addEventListener('click', () => toggle(true));
      drawer.querySelectorAll('.rg-drawer__close,.rg-drawer__backdrop').forEach(button => button.addEventListener('click', () => toggle(false)));
    }
  };
  const header = document.querySelector('[data-rg-header]');
  if (header) { const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 40); addEventListener('scroll', onScroll, { passive: true }); onScroll(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
